import React from "react";
import _ from "lodash";
import TextCard2 from "./../text-card-step-two";
import { Typography, makeStyles, Card, Tooltip } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import {
  borderRadiusValue,
  textColor,
  textSecondary,
  createShort,
  graphicsDarkRed,
  popoverColor,
  useStepContainerStyles,
  tooltipTextSize
} from "../../lib/constants";
import { useSelector } from "react-redux";
import { Slide } from "@material-ui/core";

const useS2ContainerStyles = makeStyles(
  {
    selectedCardCard: {
      width: "81%",
      boxShadow: "0 1.5px 12px 2px rgb(0 0 0 / 6%)",
      borderRadius: borderRadiusValue,
      padding: "7px",
      marginTop: "7px",
      display: "flex",
      flexDirection: "row",
      alignItems: "center"
    },

    selectedTextContainer: {
      display: "flex",
      flexDirection: "column",
      marginLeft: "10px"
    },

    selectedCardHeader: {
      fontWeight: 500,
      color: textColor
    },

    selectedCardText: {
      color: textSecondary
    },

    tooltipStyling: {
      color: textColor,
      backgroundColor: `${popoverColor} !important`,
      padding: "8px",
      borderRadius: borderRadiusValue,
      fontSize: tooltipTextSize,
      boxShadow: "rgb(213, 213, 213) 6px 6px 12px, rgb(255, 255, 255) -6px -6px 12px",
      fontWeight: "normal"
    }
  },
  { name: "S2ContainerStyles" }
);

export default function Step2Container(props) {
  const { content, onClickCard, needResize } = props;
  const classes = useS2ContainerStyles();
  const stepContainerClasses = useStepContainerStyles({
    scrolling: needResize[1]
  });

  const pageNumber = useSelector((state) => state.pageNumber);

  const checkedTitleStepOne = useSelector((state) => state.checkedCardTitle);

  // values for checked text from step 1
  const checkedStepOne = useSelector((state) => state.checkedCardStepOne);

  // shorten down checked text from step 1 to display it
  const shortLength = 19;
  const short = checkedStepOne?.split(" ");

  return (
    <Slide direction={pageNumber === 2 ? "up" : "down"} in={pageNumber === 2} timeout={500} mountOnEnter unmountOnExit>
      <div className={stepContainerClasses.textContainerGrid}>
        <Card classes={{ root: classes.selectedCardCard }}>
          <Tooltip title="Ausgewählter Ausgangstext" classes={{ tooltip: classes.tooltipStyling }}>
            <CheckCircleIcon style={{ color: graphicsDarkRed + "70", fontSize: "25px" }} />
          </Tooltip>
          <div className={classes.selectedTextContainer}>
            <Typography classes={{ root: classes.selectedCardHeader }} key="cardHeader">
              {checkedTitleStepOne}
            </Typography>
            <Typography classes={{ root: classes.selectedCardText }} key="cardText">
              {createShort(short, shortLength)}
            </Typography>
          </div>
        </Card>
        {_.map(content, (text, index) => (
          <TextCard2
            header={text[0]}
            text={text[1]}
            onCheck={(text) => onClickCard(text)}
            key={`text-card-step-two-${index}`}
            resize={needResize}
          />
        ))}
      </div>
    </Slide>
  );
}
